var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTableSortHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_table_sort_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.705,0 L2.32383717,1.74392474 C2.69727159,2.14621444 3.30003117,2.1491201 3.67616283,1.74392474 L5.295,0 L5.32529297,0.0327049595 C5.69792337,0.435004991 5.70138073,1.08352958 5.31925356,1.49608252 L3.68074644,3.26505108 C3.30478056,3.67095216 2.70138073,3.67760403 2.31925356,3.26505108 L0.680746436,1.49608252 C0.304780561,1.09018144 0.303074913,0.433927219 0.674707031,0.0327049595 L0.705,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.705,6 L2.32383717,7.74392474 C2.69727159,8.14621444 3.30003117,8.1491201 3.67616283,7.74392474 L5.295,6 L5.32529297,6.03270496 C5.69792337,6.43500499 5.70138073,7.08352958 5.31925356,7.49608252 L3.68074644,9.26505108 C3.30478056,9.67095216 2.70138073,9.67760403 2.31925356,9.26505108 L0.680746436,7.49608252 C0.304780561,7.09018144 0.303074913,6.43392722 0.674707031,6.03270496 L0.705,6 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_table_sort_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    transform: "translate(9.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#5697B7",
    transform: "translate(3.000000, 2.000000) rotate(180.000000) translate(-3.000000, -2.000000) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#5697B7",
    transform: "translate(3.000000, 8.000000) scale(1, -1) rotate(180.000000) translate(-3.000000, -8.000000) ",
    xlinkHref: "#path-3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableSortHover);
export default __webpack_public_path__ + "static/media/icon_table_sort_hover.f9e57d95ab5b51dcd1693cfee1772fc0.svg";
export { ForwardRef as ReactComponent };